export default __webpack_public_path__ + "static/media/Jerry.be9243de.jpeg";